/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Integrations {
    "use strict";

    export class IntegrationsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.integration;
            this.sectionTemplatePath = "app/plugins/integrations/sectionViews/";
            this.entityType = 'Integration';

            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_INTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.baseEndpoint, '',
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Integration, this.appSettings, this.busyService, this.securityKeys.MANAGEMENT_INTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            this.sections.push(new LogSection(1, "SECTION_INTEGRATIONS_ERROR_LOG", "log.html", false, false, this.baseEndpoint, '',
                this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Integration, this.appSettings, this.modalService, this.busyService));
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        selectSection(item): void {
            if (item.sectionId === 0) { // main tab
                this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_INTEGRATION_TAB_MAIN);
            } else { // error log tab
                // todo: build security key for Error Log tab
                // this.buildCrudSecurityKeysBase('');
            }

            super.selectSection(item);
        }

        get showEdit(): boolean {
            if (this.selectedSection instanceof Meevo.Plugins.Integrations.LogSection) {
                return false;
            }

            return super.showEditLogic();
        }
    }
}